__turbopack_context__.v({
  "container_footer_at_bottom": "styles-module-scss-module__J-8bzG__container_footer_at_bottom",
  "main": "styles-module-scss-module__J-8bzG__main",
  "preview_alert": "styles-module-scss-module__J-8bzG__preview_alert",
  "preview_desktop_title": "styles-module-scss-module__J-8bzG__preview_desktop_title",
  "preview_mobile_title": "styles-module-scss-module__J-8bzG__preview_mobile_title",
  "theme_gradient": "styles-module-scss-module__J-8bzG__theme_gradient",
});
